import { render, staticRenderFns } from "./customer_high_seas_detail.vue?vue&type=template&id=175ca00b&scoped=true&"
import script from "./customer_high_seas_detail.vue?vue&type=script&lang=js&"
export * from "./customer_high_seas_detail.vue?vue&type=script&lang=js&"
import style0 from "./customer_high_seas_detail.vue?vue&type=style&index=0&id=175ca00b&prod&lang=scss&scoped=true&"
import style1 from "./customer_high_seas_detail.vue?vue&type=style&index=1&id=175ca00b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175ca00b",
  null
  
)

export default component.exports